import { render, staticRenderFns } from "./dueDate-info.vue?vue&type=template&id=d1794510&scoped=true&"
import script from "./dueDate-info.vue?vue&type=script&lang=js&"
export * from "./dueDate-info.vue?vue&type=script&lang=js&"
import style0 from "./dueDate-info.vue?vue&type=style&index=0&id=d1794510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1794510",
  null
  
)

export default component.exports